app.component("recentPatients", {
	templateUrl: "app/src/js/directives/recentPatients.html",
	controller: "recentPatientsController",
	bindings: {
		createTask: "&",
		recentData: "<?",
		onPatientSelect: "&?",
	},
});

app.controller("recentPatientsController", [
	"$scope",
	"$modal",
	"$timeout",
	"Session",
	"CurrentPatient",
	"PatientAPI",
    "$state",
	"UserService",
	function ($scope, $modal, $timeout,  Session, CurrentPatient, PatientAPI,$state,UserService) {
		$scope.CP = CurrentPatient;
		$scope.userIsPracticeAdmin = false;
		$scope.showWorkupButton = false;
		$scope.showOperationNoteButton = false;
		$scope.PA = PatientAPI;
		$scope.recentPatientList = [];
		$scope.patientBackup = null;
		$scope.Object = Object;
		$scope.isTaskEnabled = Session.practice.practiceFeatures.sendTasksWithinPracticeFeature;

		function groupBy(data) {
			if (!data) return {};

			return data
				.map((t) => ({ ...t, dateAdded: trim(t.dateAdded) }))
				.reduce((acc, item) => {
					const key = formateDate(item.dateAdded);
					if (!acc[key]) {
						acc[key] = [];
					}
					acc[key].push(item);
					return acc;
				}, {});
		}

		function setRecentPatientList(data) {
			$scope.recentPatientList = groupBy(data);
		}

		this.$onInit = function () {
			if ($scope.$ctrl.recentData) {
				setRecentPatientList($scope.$ctrl.recentData);
				return;
			}

			UserService.getRecentPatients().then(
				function (resp) {
					setRecentPatientList(resp.data);
				},
				function () {
					// Not logged: the $http error carries the bearer token and the recent-patient list.
				}
			);
		};

		$scope.$watch("$ctrl.recentData", function (newValue) {
			if (newValue) {
				setRecentPatientList(newValue);
			}
		});

		function formateDate(date){
			const array = date.split('-');
			return `${array[2]}/${array[1]}/${array[0]}`
		}

		function trim(date){
			return date.split('T')[0];
		}
	
		$scope.selectPatient = function (patient) {
			if ($scope.CP.patientBackup) {
				$scope.patientBackup = angular.copy($scope.CP.patientBackup);
			}
			$scope.CP.clearPatient();

			$timeout(function () {
				$scope.CP.setPatient(patient);

				if (!$scope.CP.patientIsMine) {
					// Launch the new standalone transfer modal
					$modal({
						controller: "patientTransferController",
						templateUrl: "app/src/views/templates/modal.patient-transfer-flow.tpl.html",
						show: true,
						backdrop: "static",
						resolve: {
							patientId: function () {
								return patient.id;
							},
							onSuccess: function () {
								return function (updatedPatient) {
									$scope.CP.setPatient(updatedPatient);
									$state.go("patient-dashboard");
								};
							},
							onCancel: function () {
								return function () {
									// Restore the backup if they cancel
									if ($scope.patientBackup) {
										$scope.CP.setPatient($scope.patientBackup);
									} else {
										$scope.CP.clearPatient();
									}
								};
							}
						}
					});
				} else {
					$state.go("patient-dashboard");
				}
			});
		};

		$scope.switchPatient = function (patientId) {
			if ($scope.$ctrl.onPatientSelect) {
				$scope.$ctrl.onPatientSelect();
			}
			if($scope.CP.patient.id === patientId){
				return;
			}
			$scope.PA.isProcessing = true;
			$scope.PA.getPatient(patientId).then(function (resp){
				$scope.selectPatient(resp.data);
			}, function (error) {
				$scope.serverErrorModal = $modal({
					scope: $scope,
					templateUrl: "app/src/views/templates/modal.server-error.tpl.html",
					show: true,
					title: "CatTrax has encountered an error",
				});
			}).then(function (){
				$scope.PA.isProcessing = false;
			});
		}
	},
]);
